import React from 'react';
import { BookOpenIcon, ZapIcon, FileTextIcon, MessageSquareIcon, BarChart3Icon, TargetIcon, FileIcon, BotIcon, InfinityIcon } from 'lucide-react';
import { Section, Reveal, SectionTitle } from './Section';
const tomos = [{
  icon: ZapIcon,
  color: 'text-brand-orange',
  bg: 'bg-brand-orange/10',
  title: 'Tomo 1: La Muerte del Domingo de Trabajo',
  desc: 'El método para dejar de llevarte exámenes a casa para siempre.'
}, {
  icon: FileTextIcon,
  color: 'text-brand-teal',
  bg: 'bg-brand-teal/10',
  title: 'Tomo 2: Tu Bóveda de Plantillas “Click & Print”',
  desc: 'Exámenes listos para imprimir que se corrigen casi solos.'
}, {
  icon: MessageSquareIcon,
  color: 'text-brand-pink',
  bg: 'bg-brand-pink/10',
  title: 'Tomo 3: Dile Adiós al Bolígrafo Rojo',
  desc: 'Cómo dar feedback brillante a 30 alumnos en un minuto sin escribir.'
}, {
  icon: BarChart3Icon,
  color: 'text-brand-green',
  bg: 'bg-brand-green/10',
  title: 'Tomo 4: El Asistente Digital Invisible',
  desc: 'Domina tus notas sin Excel complicados y olvida el cálculo manual de promedios.'
}, {
  icon: TargetIcon,
  color: 'text-brand-purpleLight',
  bg: 'bg-brand-purpleLight/10',
  title: 'Tomo 5: Evaluación Relámpago para Proyectos',
  desc: 'Evalúa maquetas, exposiciones y ensayos sin que te duelan los ojos.'
}, {
  icon: BookOpenIcon,
  color: 'text-brand-purple',
  bg: 'bg-brand-purple/10',
  title: 'Tomo 6: Cero Exámenes Pendientes',
  desc: 'El plan de choque para eliminar todas tus evaluaciones acumuladas hoy mismo.'
}];
const receives = [{
  icon: BookOpenIcon,
  text: 'Los 6 tomos completos del Sistema Corrige Evaluaciones en 30 minutos.'
}, {
  icon: FileIcon,
  text: 'Todos los materiales en formato PDF de alta calidad.'
}, {
  icon: FileTextIcon,
  text: 'Plantillas listas para adaptar a cualquier grado y área.'
}, {
  icon: BotIcon,
  text: 'Recursos para aprovechar herramientas digitales e inteligencia artificial.'
}, {
  icon: InfinityIcon,
  text: 'Acceso de por vida con descarga inmediata.'
}];
export function WhatsIncluded() {
  return <Section id="incluye" className="bg-white" data-id="element-199">
      <Reveal className="text-center" data-id="element-200">
        <SectionTitle data-id="element-201">¿Qué incluye el sistema?</SectionTitle>
      </Reveal>

      <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-202">
        {tomos.map((t, i) => <Reveal key={t.title} delay={i * 0.05} className="rounded-2xl border border-brand-purple/10 bg-white p-5 shadow-sm" data-id="element-203">
            <div className={`mb-3 flex h-11 w-11 items-center justify-center rounded-xl ${t.bg}`} data-id="element-204">
              <t.icon className={`h-6 w-6 ${t.color}`} data-id="element-205" />
            </div>
            <h3 className="font-display text-lg font-extrabold text-brand-purpleDark" data-id="element-206">
              {t.title}
            </h3>
            <p className="mt-1 text-sm font-semibold text-brand-purpleDark/70" data-id="element-207">
              {t.desc}
            </p>
          </Reveal>)}
      </div>

      <Reveal className="mt-10 rounded-3xl bg-brand-cream p-6 ring-1 ring-brand-purple/10" data-id="element-208">
        <h3 className="text-center font-display text-xl font-extrabold text-brand-purpleDark sm:text-2xl" data-id="element-209">
          ¿Qué recibirás inmediatamente después de comprar?
        </h3>
        <ul className="mt-5 space-y-3" data-id="element-210">
          {receives.map(r => <li key={r.text} className="flex items-start gap-3" data-id="element-211">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-teal/15" data-id="element-212">
                <r.icon className="h-4 w-4 text-brand-teal" data-id="element-213" />
              </span>
              <p className="text-sm font-semibold text-brand-purpleDark/85" data-id="element-214">
                {r.text}
              </p>
            </li>)}
        </ul>
        <p className="mt-5 text-center text-sm font-bold text-brand-purple" data-id="element-215">
          Todo organizado para que empieces a ahorrar tiempo desde el primer
          día.
        </p>
      </Reveal>
    </Section>;
}